@if (showHint) {
  <div class="alert alert-info alert-dismissible fade show" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onHintDismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <p><b>{{ resources.Info }}:</b></p>
    <div [innerHTML]="resources.MissingSimInfo | sanitizeHtml"></div>
  </div>
}
<div class="card">
  <div class="card-body">
    <form [formGroup]="searchComponentsForm" (ngSubmit)="onSearch()" class="row">
      <div class="form-group col-lg-2 col-md-3 col-xs-12">
        <label>{{resources.Market}}:</label>
        <div class="input-group">
          <select formControlName="selectedMarket" class="form-control" required>
            <option value="" disabled="disabled"></option>
            @for (market of marketList | async; track market) {
              <option [ngValue]="market.id">
                {{market.name}}
              </option>
            }
          </select>

        </div>
      </div>
      <div class="form-group col-md-2 col-xs-12">
        <label>&nbsp;</label>
        <button class="btn btn-primary form-control" type="submit">
          {{resources.Search}}
        </button>
      </div>
    </form>
  </div>
</div>

  <div class="panel" style="margin-top: 5px;">
    <div class="panel-body">
      <cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="dataList | async" (sortTriggered)="onSort($event)"
        (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilterAndSorting()"
        [isLoading]="isLoading | async" [dataTotalCount]="totalCount | async"
        [filterExpression]="filterExpression | async"
      (exportToExcelTriggered)="onExportToExcel()"></cal-calsiumlist-listing>
      <cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async">
      </cal-pagination>
    </div>
  </div>
